$.fn.extend({
    refreshGrid: function () {
        this.data("kendoGrid").dataSource.read();
        return this;
    },
    maskGrid: function (message) {
        this.data("kendoGrid").mask(message);
        return this;
    },
    unmaskGrid: function () {
        this.data("kendoGrid").unmask();
        return this;
    }
});
